import { lazy } from 'react';

import { useRoutes } from 'react-router-dom';

// project import
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import CommonLayout from 'layout/CommonLayout';
import AdminRoutes from './AdminRoutes';
import { withFooter } from './withFooter';

import Loadable from 'components/Loadable';
const PagesLanding = Loadable(lazy(() => import('pages/landing')));
const AiLanding = Loadable(lazy(() => import('pages/ai')));
const InstagramLanding = Loadable(lazy(() => import('pages/instagram-landing')));
const InterviewsLanding = Loadable(lazy(() => import('pages/inter')));
const InterviewsLandingPage = Loadable(lazy(() => import('pages/landings/interviews')));
const CompetitionLandingPage = Loadable(lazy(() => import('pages/landings/competition')));
const ReviewsLandingPage = Loadable(lazy(() => import('pages/landings/reviews')));
const AndrewChenWtfAnalysis = Loadable(lazy(() => import('pages/lead-magnets/andrew-chen-wtf-analysis1')));
const MajaVojeBeachhead = Loadable(lazy(() => import('pages/lead-magnets/maja-voje-beachhead')));
const VeronicaLeadMagnet = Loadable(lazy(() => import('pages/lead-magnets/veronica-lead-magnet')));
const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));
const FeaturesLanding = Loadable(lazy(() => import('pages/landings/features')));
const TrendsLandingPage = Loadable(lazy(() => import('pages/landings/trends')));
const ICPLandingPage = Loadable(lazy(() => import('pages/landings/icp')));
const MarketersLandingPage = Loadable(lazy(() => import('pages/landings/marketers')));
const AgencyLandingPage = Loadable(lazy(() => import('pages/landings/agencies')));
const StartupsLandingPage = Loadable(lazy(() => import('pages/landings/startups')));
// const CompanyTaskPage = Loadable(lazy(() => import('pages/landings/company-task')));

// ==============================|| ROUTING RENDER ||============================== //

// Create wrapped components for landing routes
const LandingLayout = withFooter(CommonLayout, { layout: 'landing' });

export default function ThemeRoutes() {
  return useRoutes([
    {
      path: '/',
      element: <LandingLayout />,
      children: [
        {
          path: '/',
          element: <PagesLanding />
        }
        // {
        //   path: '/ab-1',
        //   element: <ExperimentPagesLanding />
        // }
      ]
    },
    {
      path: '/ai',
      element: <LandingLayout />,
      children: [
        {
          path: '',
          element: <AiLanding />
        }
      ]
    },

    {
      path: '/mobile',
      element: <LandingLayout />,
      children: [
        {
          path: '',
          element: <InstagramLanding />
        }
      ]
    },
    {
      path: '/user-interviews',
      element: <LandingLayout />,
      children: [
        {
          path: '',
          element: <InterviewsLandingPage />
        }
      ]
    },
    {
      path: '/competition-analysis',
      element: <LandingLayout />,
      children: [
        {
          path: '',
          element: <CompetitionLandingPage />
        }
      ]
    },
    {
      path: '/reviews-analysis',
      element: <LandingLayout />,
      children: [
        {
          path: '',
          element: <ReviewsLandingPage />
        }
      ]
    },
    {
      path: '/icp-analysis',
      element: <LandingLayout />,
      children: [
        {
          path: '',
          element: <ICPLandingPage />
        }
      ]
    },
    {
      path: '/for-marketers',
      element: <LandingLayout />,
      children: [
        {
          path: '',
          element: <MarketersLandingPage />
        }
      ]
    },
    {
      path: '/for-agencies',
      element: <LandingLayout />,
      children: [
        {
          path: '',
          element: <AgencyLandingPage />
        }
      ]
    },
    {
      path: '/for-startups',
      element: <LandingLayout />,
      children: [
        {
          path: '',
          element: <StartupsLandingPage />
        }
      ]
    },
    {
      path: '/market-trends-landing',
      element: <LandingLayout />,
      children: [
        {
          path: '',
          element: <TrendsLandingPage />
        }
      ]
    },
    {
      path: '/interviews-landing',
      element: <LandingLayout />,
      children: [
        {
          path: '',
          element: <InterviewsLanding />
        }
      ]
    },
    {
      path: '/features',
      element: <LandingLayout />,
      children: [
        {
          path: '',
          element: <FeaturesLanding />
        }
      ]
    },
    {
      path: '/andrew-chen-wtf-analysis',
      element: <LandingLayout />,
      children: [
        {
          path: '',
          element: <AndrewChenWtfAnalysis />
        },
        {
          path: ':taskId',
          element: <AndrewChenWtfAnalysis />
        }
      ]
    },
    {
      path: '/maja-voje-beachhead',
      element: <LandingLayout />,
      children: [
        {
          path: '',
          element: <MajaVojeBeachhead />
        },
        {
          path: ':taskId',
          element: <MajaVojeBeachhead />
        }
      ]
    },
    {
      path: '/veronica-lead-magnet',
      element: <LandingLayout />,
      children: [
        {
          path: '',
          element: <VeronicaLeadMagnet />
        },
        {
          path: ':taskId',
          element: <VeronicaLeadMagnet />
        }
      ]
    },
    AdminRoutes,
    LoginRoutes,
    MainRoutes,
    // Programmatic SEO: Company+Task pages (e.g., /nike-competitors, /hubspot-swot-analysis)
    // Temporarily disabled:
    // {
    //   path: '/:slug',
    //   element: <LandingLayout />,
    //   children: [
    //     {
    //       path: '',
    //       element: <CompanyTaskPage />
    //     }
    //   ]
    // },
    {
      path: '*',
      element: <LandingLayout />,
      children: [
        {
          path: '*',
          element: <MaintenanceError />
        }
      ]
    }
  ]);
}
